module.exports = __webpack_public_path__ + "static/media/chess2.6c6e7581.png";